// src/app/routes/icvRoutes.jsx
import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import RequireFaskesAuth from "../../auth/RequireFaskesAuth";

const LayananKerjaSamaIcvPage = lazy(() => import("../../pages/LayananKerjaSamaIcvPage"));
const LayananKerjaSamaIcvPengajuanPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvPengajuanPage")
);
const LayananKerjaSamaIcvDokumenPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvDokumenPage")
);
const LupaPasswordIcvPage = lazy(() => import("../../pages/LupaPasswordIcvPage"));
const LayananKerjaSamaIcvDashboardPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvDashboardPage")
);
const LayananKerjaSamaIcvKuotaPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvKuotaPage")
);
const LayananKerjaSamaIcvVaksinPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvVaksinPage")
);
const LayananKerjaSamaIcvProfilFaskesPage = lazy(() =>
  import("../../pages/LayananKerjaSamaIcvProfilFaskesPage")
);

const protectedFaskes = (element) => <RequireFaskesAuth>{element}</RequireFaskesAuth>;

export function renderIcvRoutes() {
  return (
    <>
      <Route path="/layanan-kerjasama-icv" element={<LayananKerjaSamaIcvPage />} />
      <Route
        path="/layanan-kerjasama-icv/login"
        element={<Navigate to="/layanan-kerjasama-icv" replace />}
      />
      <Route
        path="/layanan-kerjasama-icv/lupa-password"
        element={<LupaPasswordIcvPage />}
      />
      <Route
        path="/layanan-kerjasama-icv/pengajuan"
        element={<LayananKerjaSamaIcvPengajuanPage />}
      />
      <Route
        path="/layanan-kerjasama-icv/dokumen"
        element={<LayananKerjaSamaIcvDokumenPage />}
      />
      <Route
        path="/layanan-kerjasama-icv/dashboard"
        element={protectedFaskes(<LayananKerjaSamaIcvDashboardPage />)}
      />
      <Route
        path="/layanan-kerjasama-icv/kuota"
        element={protectedFaskes(<LayananKerjaSamaIcvKuotaPage />)}
      />
      <Route
        path="/layanan-kerjasama-icv/vaksin"
        element={protectedFaskes(<LayananKerjaSamaIcvVaksinPage />)}
      />
      <Route
        path="/layanan-kerjasama-icv/profil"
        element={protectedFaskes(<LayananKerjaSamaIcvProfilFaskesPage />)}
      />
    </>
  );
}
